export default __webpack_public_path__ + "static/iso-27701-fd591ca960144e7e026a788e916456ee.svg";